import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Loader from "@/components/Loader";

export default function ProtectedRoute({ children }) {
  const { status } = useAuth();
  if (status === "loading") return <Loader />;
  if (status === "guest") return <Navigate to="/login" replace />;
  return children;
}
